import React from "react";
import lazyPage from "../../../common/helpers/lazyPage";
import Loader from "../Loader";

export default lazyPage(
    "src/front/components/ComposerForm/ComposerForm.tsx",
    () => import("./ComposerForm"),
    <Loader margin="auto" />,
);
